<ik-card-selectable [isSelected]="true">
  <ng-container badge>
    {{"Acces accordes" | transloco}}
  </ng-container>
  <ng-container header>
    {{invitation.extras.full_access ? ('Acces complet' | transloco) : 'Acces limite' | transloco}}
    <!--        <span class="admin">{{invitation.extras.full_access ? ('(Admin.)' | transloco) : ''}}</span>-->
  </ng-container>
  <ng-container main>
    <app-ik-card-selectable-icon-item [cards]="invitation.extras.full_access ? fullAccess : limitedAccess">
    </app-ik-card-selectable-icon-item>
  </ng-container>
</ik-card-selectable>
